import gates from './gates'

export default {
  fields: {
    gates,
  },
}
